import { Keyframes } from '@ant-design/cssinjs'

// ── 主色系 (cyan) ──
export const cyan = {
  50: '#ecfeff',
  100: '#cffafe',
  200: '#a5f3fc',
  300: '#67e8f9',
  400: '#22d3ee',
  500: '#06b6d4',
  600: '#0891b2',
  700: '#0e7490',
  800: '#155e75',
  900: '#164e63',
}

// ── 辅色系 (blue) ──
export const blue = {
  400: '#60a5fa',
  500: '#3b82f6',
  600: '#2563eb',
}

// ── 强调色 (indigo) ──
export const indigo = {
  400: '#818cf8',
  500: '#6366f1',
  600: '#4f46e5',
}

// ── 深空背景色系 (slate) ──
export const slate = {
  950: '#020617',
  900: '#0f172a',
  800: '#1e293b',
  700: '#334155',
  600: '#475569',
  500: '#64748b',
  400: '#94a3b8',
  300: '#cbd5e1',
  200: '#e2e8f0',
}

// ── 发光阴影 ──
export const glowSm = `0 0 6px ${cyan[500]}40, 0 0 2px ${cyan[500]}80`
export const glowMd = `0 0 12px ${cyan[500]}50, 0 0 4px ${cyan[500]}90`
export const glowLg = `0 0 20px ${cyan[500]}60, 0 0 6px ${cyan[500]}a0`

// ── shimmer 扫光动画 ──
export const shimmerKeyframes = new Keyframes('nextgen-shimmer', {
  '0%': { backgroundPosition: '-200% 0' },
  '100%': { backgroundPosition: '200% 0' },
})
